(() => {
 class CategoryFilters extends HTMLElement {
  connectedCallback() {
   if(this.ready) return; this.ready=true;
   const form=this.querySelector('.bc-category-search'), input=form.querySelector('input'), topic=this.querySelector('[data-topic]');
   const facets=[...this.querySelectorAll('[data-facet]')];
   const current=new URL(location.href), query=current.searchParams.get('bc_q')||'';
   for(const select of facets) {
    const value=current.searchParams.get(`bc_${select.dataset.facet}`);
    if(value && [...select.options].some(option=>option.value===value)) select.value=value;
   }
   input.value=query;
   const label=document.querySelector('[data-search-label]'); if(label && query) label.textContent=`for “${query}”`;
   form.hidden=false;
   const navigate=()=>{
    const term=input.value.trim();
    const selected=facets.map(select=>select.value).filter(Boolean);
    const number=facets.length && term.match(/^(?:#|BO-|No\.?\s*)?(\d{1,3})$/i);
    if(number) selected.push(`original-${number[1].padStart(3,'0')}`);
    if(!term || number){const option=topic?.selectedOptions[0];const path=selected.length?`${this.dataset.collectionUrl}/${selected.map(encodeURIComponent).join('+')}`:option?.dataset.path||this.dataset.collectionUrl;const url=new URL(path,location.origin); const sort=this.querySelector('[name=sort_by]')?.value;if(sort)url.searchParams.set('sort_by',sort);if(number)url.searchParams.set('bc_q',term);location.href=url.href;return;}
    const quote=value=>'"'+value.replaceAll('\\','\\\\').replaceAll('"','\\"')+'"';
    const clauses=[`tag:${this.dataset.categoryTag}`];
    clauses.push(...selected.map(tag=>`tag:${quote(tag)}`));
    clauses.push(...term.split(/\s+/).map(word => facets.length?quote(word):`title:${quote(word)}`));
    const url=new URL(this.dataset.searchUrl,location.origin);
    url.searchParams.set('view','bc-category');url.searchParams.set('type','product');url.searchParams.set('q',clauses.join(' AND '));url.searchParams.set('bc_q',term);
    for(const select of facets) if(select.value) url.searchParams.set(`bc_${select.dataset.facet}`,select.value);
    location.href=url.href;
   };
   form.addEventListener('submit',event=>{event.preventDefault();navigate();});
   topic?.addEventListener('change',()=>{input.value='';navigate();});
   facets.forEach(select=>select.addEventListener('change',navigate));
   if(facets.length) this.querySelector('.bc-category-sort')?.addEventListener('submit',event=>{event.preventDefault();navigate();});
  }
 }
 if(!customElements.get('bc-category-filters'))customElements.define('bc-category-filters',CategoryFilters);
})();
